import { useEffect, useState } from 'react';
import { authService } from '../services/api';

export default function useAdminPermissions() {
  const [session, setSession] = useState({ loading: true, permissions: [], roles: [], status: null });
  useEffect(() => {
    let active = true;
    authService.me().then(({ data }) => {
      if (active) setSession({ ...data, loading: false, status: 200 });
    }).catch(error => {
      if (active) setSession({ loading: false, permissions: [], roles: [], status: error.response?.status || 0 });
    });
    return () => { active = false; };
  }, []);
  return { ...session, can: permission => session.roles.includes('super_admin') || session.permissions.includes(permission) };
}
